import React, { useState } from "react";
import WarningBanner from "Components/warningBanner/WarningBanner";
import Button from "Components/button/Button";
import t from "Utils/translation";
import cx from "classnames";
import s from "../../delivery.scss";
import QboxmailApi from "@/qboxmailApi";
import { alertSuccess } from "@/utils/alerts";
const api = new QboxmailApi({ useCookie: true });

function DeliveryDomainApproval({ domain, isLoggedUserAdmin, onUpdate }) {
  const [skipping, setSkipping] = useState(false);

  const not_approved = domain.approval_status !== "approved" && domain.approval_status !== "pending";

  const skip = async (e) => {
    e.preventDefault();
    setSkipping(true);
    //eslint-disable-next-line
    const success = await api.skipValidateDeliveryDomain(domain.code).catch(async (err) => {
      return false;
    });

    if (success) {
      if (onUpdate) await onUpdate();
      alertSuccess(t("alert.deliveryDomain.approvalSkip.success"));
    }

    setSkipping(false);
  };

  return (
    <div className={s.dashboardContainer}>
      <div className={s.dashboardContent}>
        <div className={s.dashboardItem1}>
          <div className="settingTitle">{t("delivery.domains.approval.info.title")}</div>
          <div className="sectionDesc">{t("delivery.domains.approval.info.desc")}</div>
          <div className="mt-8">
            <Button docsKey="deliveryDomainsApproval" className="btnDocsFP" color="docs" sizeSmall>
              button.docs
            </Button>
          </div>
        </div>
        <div className={s.dashboardItem2}>
          {domain.approval_status === "need_approval" && (
            <>
              <WarningBanner msg={t("delivery.domains.approval.info.message.needApproval")} />

              {isLoggedUserAdmin && (
                <>
                  <div className={cx("mt-8")}>
                    <Button className={s.skipBtn} onClick={skip} color="outline" loading={skipping}>
                      button.approveDomain
                    </Button>
                  </div>

                  <div className="my-3 sectionDesc">{t("delivery.domains.approval.approveAndActivate.warningMsg")}</div>
                </>
              )}
            </>
          )}
          {domain.approval_status === "approved" && (
            <WarningBanner color="blue" msg={t("delivery.domains.approval.info.message.approved")} info />
          )}
          {domain.approval_status === "pending" && (
            <WarningBanner color="blue" msg={t("delivery.domains.approval.info.message.pending")} />
          )}

          {not_approved && domain.approval_status !== "need_approval" && (
            <>
              <WarningBanner color="light-red" msg={""} />
              <div className="section sectionInfo">{t("delivery.domains.approval.info.message.notApproved")}</div>
              <div className="section">
                <div className="settingTitle">{""}</div>
                <div className="sectionDesc">{""}</div>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
}

export default DeliveryDomainApproval;
